import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'spt-new-subscription-page',
  templateUrl: './new-subscription-page.component.html',
  styleUrls: ['./new-subscription-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewSubscriptionPageComponent implements OnInit {

  constructor(private router: Router) {
  }
  ngOnInit(): void {

  }
  clickTier(tier: number) {
    this.router.navigate(['checkout'], {
      queryParams: {
        s: tier
      }
    });
  }
}
